// import external dependencies
/* global limit_calendar_dates */
import 'jquery';
import 'slick-carousel';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import homejs from './blocks/home';
import vouchers from './util/vouchers';


/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  homejs,
  vouchers,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

jQuery(document).ready(() => {
  // Selectors
  //let arriveDate = document.querySelector('input#field_arrivedate');
  let numOfPeople = document.querySelector('#field_numofpeople');
  let selectedProduct = document.querySelector('#field_selectedproduct');
  //let test = document.querySelector('#ui-datepicker-div');

  let submit_button = document.querySelector('#form_quickorder .frm_final_submit');
  if (submit_button) {
    submit_button.setAttribute('disabled', true);
    submit_button.classList.add('submit-button-disabled');
  }


  if (numOfPeople!== null && selectedProduct!==null) {
    numOfPeople.addEventListener('change', checkTicketAvailability);
    selectedProduct.addEventListener('change', checkTicketAvailability);
  }

  let selectDateOfArrivalChange = false;
  let selectNumberOfTicketsChange = false;


  // Datepicker default set to hebrew
  jQuery.datepicker.setDefaults($.datepicker.regional['he']);



  /**
   * Checks if the current device is a mobile device
   * @returns {boolean}
   */
  let isMobile = function(){
    var isMobile = window.matchMedia('only screen and (max-width: 760px)');
    return isMobile.matches ? true : false
  }

  /**
   * Function click automatically on the 'click here' button in the voucher
   */
  let voucherOnMobile = function () {

    if (isMobile()) {
      jQuery('.showVoucherButton').trigger('click').css('display', 'none');
    }
  }

  let placeOrderOnMobile = function () {

    if (isMobile()) {
      jQuery('#place_order').text('לסיום ואישור הזמנה');
    }
  }
  voucherOnMobile();
  placeOrderOnMobile();

  // Variable to determine if the current device is mobile or not - used in the datepicker of gan guru
  // for mobile - show only 1 month.for larger devices ,show 2 months
   let mobile = isMobile();

  // Gan guru date picker
  // let datePickerEndDate = '31/08/2022';

  if (jQuery('input#field_arrivedate').length) {
    jQuery('input#field_arrivedate, input#dateOfArrivalSelector').datepicker({
      numberOfMonths:  mobile ? 1 :2,
      dateFormat: 'dd/mm/yy',
      autoclose: true,
      autoHide: true,
      isRTL: true,
      onSelect : function () {
         //$(this).trigger('change');
        checkTicketAvailability();
      },

    });
    //disable date by Orit
    const dateObj = new Date();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    const year = dateObj.getFullYear();
    const output = day + '/' + month + '/' + year;

    // eslint-disable-next-line no-undef
    jQuery('#field_arrivedate').datepicker('option', 'maxDate', datePickerEndDate);
    jQuery('#field_arrivedate').datepicker('option', 'minDate', output);
  }

  // rural accommodation date picker - check-in date - Custom constructor for blocking saturdays check-in
  if (jQuery('input#field_arrivedate2').length) {
    jQuery('input#field_arrivedate2').datepicker({
      numberOfMonths: 2,
      dateFormat: 'dd/mm/yy',
      minDate: new Date(),
      autoclose: true,
      autoHide: true,
      isRTL: true,
      beforeShowDay: function(date) {
        var day = date.getDay();
        return [(day != 6), ''];
      },

    });
    // rural accommodation date picker - check-out date
    jQuery('input#field_9n36n').datepicker({
      numberOfMonths: 2,
      dateFormat: 'dd/mm/yy',
      minDate: new Date(),
      autoclose: true,
      autoHide: true,
      isRTL: true,
    });

  }

  // When rural accommodation date from is selected , we allow rural accommodation date to show only same and future dates
  jQuery('input#field_arrivedate2').datepicker().on('change', function(e) {
    let rural_accommodation_date_from = e.target.value;
    jQuery('#field_9n36n').datepicker('option', 'minDate', rural_accommodation_date_from);
  });

  if (jQuery('input#productDatePicker').length) {
    let disabledDates = jQuery('script#disabledDates').text().replaceAll('&quot;', '"').replaceAll('\\', '')
    let allDisabledDates = []
    disabledDates = JSON.parse(disabledDates)
    for (let i = 0; i < disabledDates.length; i++) {
      allDisabledDates.push(disabledDates[i].date)
    }

    // eslint-disable-next-line no-inner-declarations
    function nonWorkingDates(date) {
      let day = date.getDate();
      let month = date.getMonth() + 1;
      if (month < 10) {
        month = '0' + month;
      }
      let year = date.getFullYear();
      let parsedDate = day + '/' + month + '/' + year;
      if (allDisabledDates.indexOf(parsedDate) > -1) {
        return [false]
      } else {
        if (day < 10) {
          parsedDate = '0' + parsedDate;
        }
        return [disabledDatesSpecial(parsedDate)];
      }
    }

    // eslint-disable-next-line no-inner-declarations
  function disabledDatesSpecial(parsedDate) {
      if (
        typeof limit_calendar_dates !== 'undefined' &&
        limit_calendar_dates!== null &&
        limit_calendar_dates.dates !== null
      ) {
        let dates = limit_calendar_dates.dates;
        if (dates.length > 0) {
          // eslint-disable-next-line no-undef
          for (let i = 0; i < dates.length; i++) {
            if (dates[i].selectedDate === parsedDate) {
              return true;
            }
          }
          return false;
        }
      }
    return true;
  }

    jQuery('input#productDatePicker').datepicker({
      numberOfMonths: 2,
      dateFormat: 'dd/mm/yy',
      beforeShowDay: nonWorkingDates,
      minDate: new Date(),
      autoHide: true,
      isRTL: true,
      onSelect: function (date) {
        console.log(date)
        jQuery('.date-error-message').parent().hide(); // hide error message when customer get his date changed and need to reselect a date
        jQuery('.date-error-message').fadeOut();
        jQuery('.activeDate').removeClass('activeDate');
        jQuery('input#billing_dateOfArrival').val(date.split('/').reverse().join('-'));
        jQuery(this).addClass('activeDate');
        let dateText = date.replaceAll('/', '');
        let selectedDate = '#hours-' + dateText;
        jQuery('.activeHours').removeClass('activeHours');
        jQuery(selectedDate).addClass('activeHours');
        jQuery('.singleDay.activeHours .singleHour:not(.disabledHours)').first().click();
        selectDateOfArrivalChange = true;
        handleTicketLimit();
        setTimeout(function () {
          if ((jQuery('.hoursWrapper .singleDay.activeHours .singleHour.disabledHours .noTicketsLeft')).length > 0 && (jQuery('.hoursWrapper .singleDay.activeHours .singleHour.activeHour')).length === 0 ) {
            jQuery('#place_order').attr('disabled', true).css({'pointer-events': 'none', 'opacity': '0.65'});
          } else {
            jQuery('#place_order').attr('disabled', false).css({'pointer-events': 'all', 'opacity': '1'});
          }

        }, 200);
      },
    });

    //disable date by Orit
    // eslint-disable-next-line no-undef
    jQuery('#productDatePicker').datepicker('option', 'maxDate', datePickerEndDate);
    jQuery('#productDatePicker').prop('readonly', true); // don't allow user to delete the date and order without a date
  }

  let getParams = function (url) {
    let params = {};
    let parser = document.createElement('a');
    parser.href = url;
    let query = parser.search.substring(1);
    let vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split('=');
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
  };
  let params = getParams(window.location.href);




  // ========================================================== HANDLE TICKET LIMIT ===================================================

  /**
   * Function provides the back end with information of : DATE, START_HOUR, END_HOUR , AMOUNT_OF_TICKETS , PRODUCT_ID
   * the backend checks if the selected number of tickets is available
   * if the tickets available the user can continue the order, if not the function calls helper functions to block the process of ordering
   */
  function handleTicketLimit() {

    let productID = jQuery('.woocommerce .quantity .qty').attr('data-id');
    let amount = jQuery('.woocommerce .quantity .qty').val();

    // if the selected number of tickets is changed, we check our backend for the number of tickets selected availability
    if (selectNumberOfTicketsChange ||  selectDateOfArrivalChange) {
      let date = jQuery('.singleDay.activeHours').attr('data-date');
      let hour = document.querySelector('.singleHour.activeHour >a').innerText;
      let start_hour = hour.substring(0,5);
      let end_hour = hour.substring(8,hour.length);
      jQuery.post('/wp-json/checkAvailableTickets/v1/checkAvailableTickets', {productID: productID, amount: amount , date  : date , start_hour : start_hour , end_hour : end_hour}).done(function () {
        // if a good response comes back then let the flow continue
        jQuery('#continueButton').attr('disabled', false).css({'pointer-events': 'all', 'opacity': '1'});
      }).fail(function (error) {
        // if a bad status returns block the ability to order tickets
        let availableTickets = error.responseJSON.data.availableTickets;
        showTicketLimitPopup(availableTickets);
      })
    }
  }

  /**
   * Function shows the div spinner-overlay which contains the div spinner
   */
  // eslint-disable-next-line no-unused-vars
  function startSpinner(){
    let fastOrderSubmitBtn = document.querySelector('.fastOrder .frm_submit button');
    let spinner = document.querySelector('.spinner-overlay');
    if (fastOrderSubmitBtn!==null && spinner!==null ) {
      spinner.style.display = 'block';
    }
  }

  /**
   * Function hides the div spinner-overlay which contains the div spinner
   */
  // eslint-disable-next-line no-unused-vars
  function stopSpinner() {
    let fastOrderSubmitBtn = document.querySelector('.fastOrder .frm_submit button');
    let spinner = document.querySelector('.spinner-overlay');
    if (fastOrderSubmitBtn!==null && spinner!==null ) {
      spinner.style.display = 'none';
    }
  }

  /**
   * Function shows that the selected number of tickets is greater than the maximum tickets available in the product settings
   * the function fetches the popup window, and appends a text with the number of tickets that the user can order
   * @param availableTickets
   */
  function showTicketLimitPopup(availableTickets) {

    jQuery('#continueButton').attr('disabled', true).css({'pointer-events': 'none', 'opacity': '0.65'});
    jQuery('#place_order').attr('disabled', true).css({'pointer-events': 'none', 'opacity': '0.65'});
    let popupNumberOfTicketsAvailable = document.querySelector('#ticketsNumberAvailable');
    if (!popupNumberOfTicketsAvailable) {return;}
    popupNumberOfTicketsAvailable.style.display = 'block';
    popupNumberOfTicketsAvailable.innerHTML = availableTickets + ' כרטיסים ';
    jQuery('#ticketsNumberOverTheLimit').parent().show();
    jQuery('#ticketsNumberOverTheLimit').fadeIn();
  }

  let ticketsLimitPopupButton = document.querySelector('.popup-tickets-limit');
  if (!ticketsLimitPopupButton) {return;}
  ticketsLimitPopupButton.addEventListener('click', function (event) {
    event.preventDefault();
    jQuery('.voucherPopup').fadeOut();
    jQuery('.popupWrapper').fadeOut();
    let popupNumberOfTicketsAvailable = document.querySelector('#ticketsNumberAvailable');
    popupNumberOfTicketsAvailable.style.display = 'none';
    popupNumberOfTicketsAvailable.innerHTML = '';
  })


  // every time someone selects the number of tickets dropdown this function is executed
  jQuery('.woocommerce .quantity .qty').on('change', () => {
    handleTicketLimit();
    let productID = jQuery('.woocommerce .quantity .qty').attr('data-id');
    let amount = jQuery('.woocommerce .quantity .qty').val();
    jQuery.post('/wp-json/updateCartQuantity/v1/updateCartQuantity', {productID: productID, amount: amount})
      .done(function (data) {
        jQuery('.totalNumber span.woocommerce-Price-amount.amount').text('₪'+ data.total);
      });

    // update other subscribers form
    if (jQuery('.otherManuy') && jQuery('.otherManuy').length) {
      let currentActiveRows = jQuery('.singleOtherManuy')
      let qty = jQuery('.woocommerce .quantity .qty').val()
      if (qty == 1) {
        for (let x = currentActiveRows.length - 1; x >= 0; x--) {
          if (x > 0) {
            jQuery(currentActiveRows[x]).remove()
          } else if (x == 0) {
            jQuery(currentActiveRows[x]).hide()
          }
        }
      } else if (qty > currentActiveRows.length) {
        for (let i = 0; i < jQuery('.woocommerce .quantity .qty').val() - currentActiveRows.length - 1; i++) {
          let manuyRow = jQuery('.singleOtherManuy');
          jQuery(manuyRow[0]).clone().appendTo('.otherManuy').find('input').val('')
        }
      } else if (qty < currentActiveRows.length) {
        for (let x = currentActiveRows.length - 1; x >= currentActiveRows.length - (currentActiveRows.length - qty) - 1; x--) {
          jQuery(currentActiveRows[x]).remove()
        }
      }

      if (qty > 1) {
        jQuery('.singleOtherManuy').show()
      }
      countOtherManuy()
    }
  });
  jQuery('.showCouponButton').on('click', (event) => {
    event.preventDefault();
    jQuery('div.checkout_coupon.woocommerce-form-coupon').toggle()
  })

  jQuery('.apply_coupon').on('click', (event) => {
    event.preventDefault();
    let couponCode = jQuery('input#coupon_code').val();
    jQuery.post('/wp-json/validateAndUpdateCoupon/v1/validateAndUpdateCoupon', {couponCode: couponCode})
      .done(function (data) {
        jQuery('.totalNumber span.woocommerce-Price-amount.amount').text('₪'+ data.total);
      })
  })

  jQuery('#upsellToggle').on('change', function () {
    let productID = jQuery(this).attr('data-id')
    let status = false;
    if (jQuery(this).is(':checked')) {
      status = true;
    }
    jQuery.post('/wp-json/addUpsellToCart/v1/addUpsellToCart', {productID: productID, amount: 1, status: status})
      .done(function (data) {
        jQuery('.totalNumber span.woocommerce-Price-amount.amount').text('₪'+ data.total);
      });
  })

  /**
   * Function responsible for switching positions of div row checkout-process and  on mobile
   */
  let changeDivPositionsOnMobile = function () {

    if (isMobile()) {
      jQuery('.row.important-to-know').insertAfter('#customer_details');
      if (jQuery('.row.cart-totals').length === 1){
        let totalPayment = jQuery('.row.cart-totals').clone();
        totalPayment.insertAfter('.row.important-to-know').css({'paddingTop' : '30px'});
      }
    }
  }

  /**
   * Function responsible for hiding voucher error messages
   */
  let hideVoucherErrors = function () {
    jQuery('.voucher-error-messages').hide();

  }

  //go to next step in product page
  jQuery('a#continueButton').click(function (e) {
    e.preventDefault();
    if ((jQuery('.hoursWrapper .singleDay.activeHours .singleHour.disabledHours .noTicketsLeft')).length > 0 && (jQuery('.hoursWrapper .singleDay.activeHours .singleHour.activeHour')).length === 0 ) {
      jQuery('#place_order').attr('disabled', true).css({'pointer-events': 'none', 'opacity': '0.65'});
    } else {
      jQuery('#place_order').attr('disabled', false).css({'pointer-events': 'all', 'opacity': '1'});
    }
    jQuery('.step2Wrapper').show().addClass('activeStep')
    jQuery(this).hide();
      hideVoucherErrors();
    jQuery('button#place_order').show();
      changeDivPositionsOnMobile();
    let allInputs = jQuery('.input-text');
    for (let i = 0; i < allInputs.length; i++) {
      let name = jQuery(allInputs[i]).attr('name')
      let labelElement = 'label[for="' + name + '"]';
      if (jQuery(allInputs[i]).val() === '') {
        jQuery(labelElement).removeClass('activeField')
        jQuery(allInputs[i]).removeClass('activeField')
      } else {
        jQuery(labelElement).addClass('activeField')
        jQuery(allInputs[i]).addClass('activeField')
      }
    }
  });

  //set active date on product page
  jQuery('a.availableDate').click(function (e) {
    e.preventDefault()
    jQuery('.activeDate').removeClass('activeDate');
    jQuery(this).addClass('activeDate');
    let selectedDate = '#hours-' + jQuery(this).attr('data-date');
    let selectedDateToDatePicker = jQuery(this).attr('title');
    jQuery('.activeHours').removeClass('activeHours')
    jQuery(selectedDate).addClass('activeHours')
    jQuery('#datepicker').val(selectedDateToDatePicker)
    setTimeout(function () {
      jQuery('.singleDay.activeHours .singleHour:not(.disabledHours)').first().click();
    }, 200);
  })
  if (jQuery('a.availableDate') && jQuery('a.availableDate').length) {
    jQuery('a.availableDate')[0].click()
  }

  //set active hours range on product page
  jQuery('.singleHour').click(function (e) {
    e.preventDefault()
    jQuery('.activeHour').removeClass('activeHour');
    jQuery(this).addClass('activeHour');
    jQuery('input#billing_timeOfArrival').val(jQuery(this).text().trim())
    //TODO: set selected data into into cart
  })

  //set selected number of people for resort gift fields
  jQuery('select#babies').on('change', function () {
    jQuery('input#billing_numberOfbabies').val(jQuery(this).val())
  })
  jQuery('select#kids').on('change', function () {
    jQuery('input#billing_numberOfkids').val(jQuery(this).val())
  })
  jQuery('select#adults').on('change', function () {
    jQuery('input#billing_numberOfAdults').val(jQuery(this).val())
  })
  jQuery('select#when').on('change', function () {
    jQuery('input#billing_when').val(jQuery(this).val())
  })
  jQuery('select#numberOfDays').on('change', function () {
    jQuery('input#billing_days').val(jQuery(this).val())
  })


  //calculate cars prices
  function calculateCarPrice(carID, amount) {
    let hiddenFullTarget = '#car' + carID + 'FullPrice';
    let hiddenSaleTarget = '#car' + carID + 'SalePrice';
    let full_price = parseInt(jQuery(hiddenFullTarget).val());
    let sale_price = parseInt(jQuery(hiddenSaleTarget).val());
    let total_full_price = amount * full_price;
    let total_sale_price = amount * sale_price;
    jQuery('p.car' + carID + 'Price .full_price').text('₪' + total_full_price)
    jQuery('p.car' + carID + 'Price .sale_price').text('₪' + total_sale_price)
    jQuery.post('/wp-json/addCrossSellToCart/v1/addCrossSellToCart', {productID: carID, amount: amount})
      .done(function (data) {
        jQuery('.totalNumber span.woocommerce-Price-amount.amount').text('₪'+ data.total);
        jQuery('#payment_method_pelecard').attr('checked', true);
      });
  }

  jQuery('.subCar').on('click', function (e) {
    e.preventDefault();
    let field_id = jQuery(this).attr('data-target');
    let target = '#car' + field_id + 'Amount'
    if (parseInt(jQuery(target).val()) > 0) {
      jQuery(target).val(parseInt(jQuery(target).val()) - 1);
      let amount = parseInt(jQuery(target).val())
      calculateCarPrice(field_id, amount)
    }
  })

  jQuery('.addCar').on('click', function (e) {
    e.preventDefault();
    let field_id = jQuery(this).attr('data-target');
    let target = '#car' + field_id + 'Amount';
    jQuery(target).val(parseInt(jQuery(target).val()) + 1);
    let amount = parseInt(jQuery(target).val())
    calculateCarPrice(field_id, amount)
  })


  //manage number of subscribers
  function countOtherManuy() {
    let numbers = jQuery('span.manuyNumber');
    for (let i = 0; i < numbers.length + 1; i++) {
      jQuery(numbers[i]).text(i + 2)
    }
  }

  jQuery('.addManuy').on('click', function (e) {
    e.preventDefault();
    let manuyRow = jQuery('.singleOtherManuy');
    if (jQuery('select[name="quantity"]').val() < 10) {
      jQuery('select[name="quantity"]').val(parseInt(jQuery('select[name="quantity"]').val()) + 1)
      if (jQuery('select[name="quantity"]').val() == 2) {
        jQuery('.singleOtherManuy').show()
      } else if (jQuery('select[name="quantity"]').val() > 2) {
        jQuery(manuyRow[0]).clone().appendTo('.otherManuy').find('input').val('')
      }
    }
    countOtherManuy()
  })

  jQuery('body').on('click', '.removeManuy', function (e) {
    e.preventDefault();
    if (jQuery('select[name="quantity"]').val() == 2) {
      jQuery('select[name="quantity"]').val(parseInt(jQuery('select[name="quantity"]').val()) - 1)
      jQuery('.singleOtherManuy').hide().find('input').val('')
    } else if (jQuery('select[name="quantity"]').val() > 2) {
      jQuery('select[name="quantity"]').val(parseInt(jQuery('select[name="quantity"]').val()) - 1)
      jQuery(this).parent().parent().remove()
    }
    countOtherManuy()
  })

  // calculate subscribers type
  jQuery('body').on('change', 'select.manuyType', function () {
    let kids = 0;
    let adults = 1;
    let types = jQuery('select.manuyType')

    for (let i = 0; i < types.length; i++) {
      if (jQuery(types[i]).val() == 'kid') {
        kids++
      } else if (jQuery(types[i]).val() == 'adult') {
        adults++
      }
    }
    jQuery('input#billing_numberOfAdultsSubs').val(adults)
    jQuery('input#billing_numberOfKidsSubs').val(kids)
  })

  jQuery('body').on('hover', 'button#place_order', function () {
    let manuyRow = jQuery('.singleOtherManuy');
    let allClients = [];
    for (let i = 0; i < manuyRow.length; i++) {
      let data = {
        type: jQuery(manuyRow[i]).find('.manuyType').val(),
        name: jQuery(manuyRow[i]).find('.manuyName').val(),
        phone: jQuery(manuyRow[i]).find('.manuyPhone').val(),
        id: jQuery(manuyRow[i]).find('.manuyID').val(),
      }
      allClients.push(data)
    }
    jQuery('input#billing_all_manuys').val(JSON.stringify(allClients))
  })

  //add multi select to contact form
  jQuery('select#field_9rywb').select2();


  //update number of vouchers in resort gift page
  function calculateVouchersPrice(voucherID, amount, weekendExtra, numberOfDays, when) {
    jQuery.post('/wp-json/updateCartQuantity/v1/updateCartQuantity', {
      productID: voucherID,
      amount: amount,
      weekendExtra: weekendExtra,
      numberOfDays: numberOfDays,
      isResort: true,
      when: when,
    })
      .done(function (data) {
        jQuery('.totalNumber span.woocommerce-Price-amount.amount').text('₪'+ data.total);
      });
  }

  jQuery('.subVoucher').on('click', function (e) {
    e.preventDefault();
    let field_id = jQuery(this).attr('data-target');
    let target = '#voucher' + field_id + 'Amount'
    let weekend_extra = jQuery('#weekendExtraID').val();
    let when = jQuery('select#when').val()
    let numberOfDays = jQuery('#numberOfDays').val()
    if (when === 'weekend') {
      jQuery('#numberOfDays option[value="1"]').attr('disabled', 'disabled')
      if (numberOfDays == 1) {
        jQuery('#numberOfDays').val(2)
      }
    } else {
      jQuery('#numberOfDays option[value="1"]').removeAttr('disabled')
    }
    if (parseInt(jQuery(target).val()) > 1) {
      jQuery(target).val(parseInt(jQuery(target).val()) - 1);
      let amount = parseInt(jQuery(target).val())
      jQuery('input#billing_vouchers').val(amount)
      jQuery('input#billing_when').val(when)
      calculateVouchersPrice(field_id, amount, weekend_extra, numberOfDays, when)
    }
  })

  jQuery('.addVoucher').on('click', function (e) {
    e.preventDefault();
    let field_id = jQuery(this).attr('data-target');
    let target = '#voucher' + field_id + 'Amount';
    let weekend_extra = jQuery('#weekendExtraID').val();
    let when = jQuery('select#when').val()
    let numberOfDays = jQuery('#numberOfDays').val()
    if (when === 'weekend') {
      jQuery('#numberOfDays option[value="1"]').attr('disabled', 'disabled')
      if (numberOfDays == 1) {
        jQuery('#numberOfDays').val(2)
      }
    } else {
      jQuery('#numberOfDays option[value="1"]').removeAttr('disabled')
    }
    jQuery(target).val(parseInt(jQuery(target).val()) + 1);
    let amount = parseInt(jQuery(target).val())
    jQuery('input#billing_vouchers').val(amount)
    jQuery('input#billing_when').val(when)
    calculateVouchersPrice(field_id, amount, weekend_extra, numberOfDays, when)
  })

  jQuery('#when').on('click', function (e) {
    e.preventDefault();
    let field_id = jQuery(this).attr('data-target');
    let target = '#voucher' + field_id + 'Amount';
    let weekend_extra = jQuery('#weekendExtraID').val();
    let when = jQuery('select#when').val()
    let numberOfDays = jQuery('#numberOfDays').val()
    if (when === 'weekend') {
      jQuery('#numberOfDays option[value="1"]').attr('disabled', 'disabled')
      if (numberOfDays == 1) {
        jQuery('#numberOfDays').val(2)
      }
    } else {
      jQuery('#numberOfDays option[value="1"]').removeAttr('disabled')
    }
    let amount = parseInt(jQuery(target).val())
    jQuery('input#billing_vouchers').val(amount)
    jQuery('input#billing_when').val(when)
    calculateVouchersPrice(field_id, amount, weekend_extra, numberOfDays, when)
  })

  jQuery('#numberOfDays').on('click', function (e) {
    e.preventDefault();
    let field_id = jQuery(this).attr('data-target');
    let target = '#voucher' + field_id + 'Amount';
    let weekend_extra = jQuery('#weekendExtraID').val();
    let when = jQuery('select#when').val()
    let numberOfDays = jQuery('#numberOfDays').val()
    if (when === 'weekend') {
      jQuery('#numberOfDays option[value="1"]').attr('disabled', 'disabled')
      if (numberOfDays == 1) {
        jQuery('#numberOfDays').val(2)
      }
    } else {
      jQuery('#numberOfDays option[value="1"]').removeAttr('disabled')
    }
    let amount = parseInt(jQuery(target).val())
    jQuery('input#billing_vouchers').val(amount)
    jQuery('input#billing_when').val(when)
    calculateVouchersPrice(field_id, amount, weekend_extra, numberOfDays, when)
  })

  if (jQuery('.addVoucher').length > 0) {
    let field_id = jQuery('.addVoucher').attr('data-target');
    let target = '#voucher' + field_id + 'Amount';
    let weekend_extra = jQuery('#weekendExtraID').val();
    let when = jQuery('select#when').val()
    let numberOfDays = jQuery('#numberOfDays').val()
    if (when === 'weekend') {
      jQuery('#numberOfDays option[value="1"]').attr('disabled', 'disabled')
      if (numberOfDays == 1) {
        jQuery('#numberOfDays').val(2)
      }
    } else {
      jQuery('#numberOfDays option[value="1"]').removeAttr('disabled')
    }
    jQuery(target).val(parseInt(jQuery(target).val()) + 1);
    let amount = parseInt(jQuery(target).val())
    jQuery('input#billing_vouchers').val(amount)
    jQuery('input#billing_when').val(when)
    calculateVouchersPrice(field_id, amount, weekend_extra, numberOfDays, when)
  }

  jQuery('body').on('click', 'button#place_order', function (e) {
    jQuery('.terms_message, .fields_message ,.fields_message_email , .fields_message_phone').hide();
    // jQuery('.error_field').removeClass('error_field')
    if (jQuery('input#billing_first_name').val() === '' ||
      jQuery('input#billing_last_name').val() === '' ||
      jQuery('input#billing_email').val() === '' ||
      jQuery('input#billing_phone').val() === '') {
      e.preventDefault();
      jQuery('.fields_message').show();
    }
    if (!validateEmail(jQuery('input#billing_email').val())) {
      e.preventDefault();
      jQuery('.fields_message_email').show();
    }
    if (!validatePhone(jQuery('input#billing_phone').val())) {
      e.preventDefault();
      jQuery('.fields_message_phone').show();
    }
    if (!jQuery('input#terms').is(':checked')) {
      e.preventDefault();
      jQuery('.terms_message').show();
    }
  })

  //use select 2 to fields
  jQuery('select').select2({
    minimumResultsForSearch: -1,
  });

  jQuery('select#field_selectedproduct').select2({
    minimumResultsForSearch: -1,
    // data: [
    //   {id: 1, title: 'asdasd', subtitle: 'asdasdasd', image:'asdasdasdasdqwe'},
    //   {id: 2, title: 'asdasd', subtitle: 'asdasdasd', image:'asdasdasdasdqwe'},
    // ],
    templateResult: function (item_select) {
      if (item_select.loading) return '';
      // eslint-disable-next-line no-undef
      let item = products_dropdown[item_select.id];
      var $container = $(
        '<div class="select2_item_wrapper">' +
        '<div class="select2-item_image"><img src="' + item.image + '" /></div>' +
        '<div class="select2-item_data">' +
        '<div class="select2-item_title"></div>' +
        '<div class="select2-item_subtitle"></div>' +
        '</div>' +
        '</div>'
      );

      $container.find('.select2-item_title').text(item.title);
      $container.find('.select2-item_subtitle').text(item.subtitle);

      return $container;
    },
  });

 let current = window.location.pathname;

  if (current!=='/'){
    // get params from url
    setTimeout(function () {
      if (params.numberOfPeople) {
        jQuery('.woocommerce .quantity .qty').select2().val(params.numberOfPeople).trigger('change');
        selectNumberOfTicketsChange=true;
        let productID = jQuery('.woocommerce .quantity .qty').attr('data-id');
        let amount = jQuery('.woocommerce .quantity .qty').val();
        jQuery.post('/wp-json/updateCartQuantity/v1/updateCartQuantity', {productID: productID, amount: amount})
          .done(function (data) {
            jQuery('.totalNumber span.woocommerce-Price-amount.amount').text('₪'+ data.total);
          });
      } else {
        jQuery('.woocommerce .quantity .qty').val(1)
        let productID = jQuery('.woocommerce .quantity .qty').attr('data-id');
        let amount = jQuery('.woocommerce .quantity .qty').val();
        jQuery.post('/wp-json/updateCartQuantity/v1/updateCartQuantity', {productID: productID, amount: amount})
          .done(function (data) {
            jQuery('.totalNumber span.woocommerce-Price-amount.amount').text('₪'+ data.total);
          })
      }

      /**
       * Function takes a date and checks if this date is restricted.
       * if the date is restricted and there are other future dates available , it will set one, otherwise it will block
       * the option to order a ticket since there are no future dates open for this product
       * @param date_to_check - string
       * @returns {*}
       */
      let change_date_if_product_has_date_restrictions  = function (date_to_check) {

        let convertFunctionParamToDate;
        let dates;
        let highestDateLimitCalendarDates;

        if (typeof limit_calendar_dates !== 'undefined' &&
          limit_calendar_dates!==null &&
          limit_calendar_dates.dates !==null &&
          limit_calendar_dates.dates.length) {

          convertFunctionParamToDate = new Date(date_to_check);
          dates = limit_calendar_dates.dates;
          highestDateLimitCalendarDates = new Date(dates[dates.length-1].selectedDate);
          let override_date = true;

          for (let i=0;i<limit_calendar_dates.dates.length;i++) {
            let date = limit_calendar_dates.dates[i].selectedDate;

            if (date_to_check === date) {
              override_date = false;
              break;
            }
          }

          if (override_date) {
            if (convertFunctionParamToDate > highestDateLimitCalendarDates) { // after iterating the limit_calendar_dates
              // we find that all the dates
              // are in the past, therefore the is no future dates available for this product,and we block the ability to order
              //jQuery('#continueButton').attr('disabled', true).css({'pointer-events': 'none', 'opacity': '0.65'});
              date_to_check = formatDate(new Date());
              jQuery('#place_order').attr('disabled', true).css({'pointer-events': 'none', 'opacity': '0.65'});
            }
            else {
              date_to_check = limit_calendar_dates.dates[0].selectedDate;
            }
            jQuery('.date-error-message').parent().show();
            jQuery('.date-error-message').fadeIn();
          }
        }

        if (typeof limit_calendar_dates !== 'undefined' && limit_calendar_dates!== null && limit_calendar_dates.dates!== null && limit_calendar_dates.dates.length === 0) {
          return null;
        }
        return date_to_check;
      }

      if (params.date) {
        setTimeout(function () {
          let changed_date = change_date_if_product_has_date_restrictions(params.date); // get the date from params and check in a function if this is restricted or not
          if (changed_date!== null) {
            jQuery('input#productDatePicker').val(changed_date);
            jQuery('.activeDate').removeClass('activeDate');
            jQuery('input#billing_dateOfArrival').val(changed_date.split('/').reverse().join('-'));
            jQuery(this).addClass('activeDate');
            let dateText = changed_date.replaceAll('/', '');
            let selectedDate = '#hours-' + dateText;
            jQuery('.activeHours').removeClass('activeHours')
            jQuery(selectedDate).addClass('activeHours')
            setTimeout(function () {
              jQuery('.singleDay.activeHours .singleHour:not(.disabledHours)').first().click();
            }, 200);
          }
          else // handles case where product have limited days but all the limited days are due and the array length is 0
          {
            jQuery('#continueButton').attr('disabled', true).css({'pointer-events': 'none', 'opacity': '0.65'});
            jQuery('#place_order').attr('disabled', true).css({'pointer-events': 'none', 'opacity': '0.65'});
            jQuery('.date-error-message').parent().show();
            jQuery('.date-error-message').fadeIn();
          }
        }, 200);
      } else {
        let current_date = change_date_if_product_has_date_restrictions(formatDate(new Date())) // current date object


        if(current_date!==null) {
          jQuery('input#productDatePicker').val(current_date) // set calendar value with current date
          jQuery('#ui-datepicker-div').css('top' , '0');
          jQuery('input#productDatePicker').datepicker('show');
          jQuery('.ui-datepicker-current-day .ui-state-active').click();
          jQuery('#ui-datepicker-div').css('top' , 'initial');
          jQuery('.activeDate').removeClass('activeDate');
          jQuery('input#billing_dateOfArrival').val(current_date.split('/').reverse().join('-'));
          let dateText = current_date.replaceAll('/', '');
          let selectedDate = '#hours-' + dateText;
          jQuery('.activeHours').removeClass('activeHours')
          jQuery(selectedDate).addClass('activeHours')

          setTimeout(function () {
            jQuery('.singleDay.activeHours .singleHour:not(.disabledHours)').first().click();
          }, 200);
           selectDateOfArrivalChange = true;
        }
      else { // handles case where product have limited days but all the limited days are due and the array length is 0
          jQuery('#continueButton').attr('disabled', true).css({'pointer-events': 'none', 'opacity': '0.65'});
          jQuery('#place_order').attr('disabled', true).css({'pointer-events': 'none', 'opacity': '0.65'});
          jQuery('.date-error-message').parent().show();
          jQuery('.date-error-message').fadeIn();
        }
      }

    }, 500)
  }



  //************************************************
  //set labeling to new inputs
  //************************************************
  jQuery('body').on('focus', '.input-text', function () {
    let name = jQuery(this).attr('name')
    let labelElement = 'label[for="' + name + '"]';
    jQuery(labelElement).addClass('activeField')
    jQuery(this).addClass('activeField')
  });

  jQuery('body').on('blur', '.input-text', function () {
    let name = jQuery(this).attr('name')
    let labelElement = 'label[for="' + name + '"]';
    if (jQuery(this).val() === '') {
      jQuery(labelElement).removeClass('activeField')
      jQuery(this).removeClass('activeField')
    }
  });

  function validateEmail(email) {
    // eslint-disable-next-line no-useless-escape
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  function validatePhone(phone) {
    // eslint-disable-next-line no-useless-escape
    const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    return re.test(String(phone).toLowerCase());
  }

  function formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [day, month, year].join('/');
  }

  jQuery('body').on('blur', 'input#billing_email', function () {
    if (validateEmail(jQuery(this).val())) {
      jQuery('.fields_message').hide()
    } else {
      jQuery('.fields_message').show()
    }
  });

  jQuery('body').on('blur', 'input#billing_phone', function () {
    if (validatePhone(jQuery(this).val())) {
      jQuery('.fields_message').hide()
    } else {
      jQuery('.fields_message').show()
    }
  });

  // ====================================== HANDLE TICKET LIMIT ON HOMEPAGE =================================

  /**
   * Function creates a popup element and renders it
   */
  function createPopupElement(availableTickets) {
    let popup = document.createElement('div');
    popup.classList.add('popupWrapper');
    popup.style.display = 'flex';
    let popupInnerDiv = document.createElement('div');
    popupInnerDiv.classList.add('voucherPopup');
    popupInnerDiv.style.display = 'flex';
    let popupInnerDivText = document.createElement('div');
    popupInnerDivText.classList.add('popupText');
    let popupTitle = document.createElement('p');
    let popupTitleText = document.createTextNode('שימו לב');
    let popupMessageText = document.createTextNode('לא ניתן להזמין את כמות הכרטיסים המבוקשת.');
    popupTitle.appendChild(popupTitleText);
    popupInnerDivText.appendChild(popupTitle);
    popupInnerDivText.appendChild(popupMessageText);
    let br = document.createElement('br');
    popupInnerDivText.appendChild(br);
    let availableTicketsParagraph = document.createElement('p');
    let availableTicketsParagraphText = document.createTextNode('לתאריך זה נותרו ');
    availableTicketsParagraph.appendChild(availableTicketsParagraphText);
    availableTicketsParagraph.appendChild(br);
    let availableTicketsNumber = document.createElement('p');
    let availableTicketsNumberText = document.createTextNode(availableTickets + ' כרטיסים ');
    availableTicketsNumber.appendChild(availableTicketsNumberText);
    availableTicketsParagraph.appendChild(availableTicketsParagraphText);
    popupInnerDivText.appendChild(availableTicketsParagraph);
    popupInnerDivText.appendChild(availableTicketsNumber);

    let button = document.createElement('button');
    button.classList.add('popup-tickets-limit');
    button.innerText = 'אישור'
    button.addEventListener('click', closePopup);


    popupInnerDiv.appendChild(popupInnerDivText);
    popupInnerDiv.appendChild(button);
    popup.appendChild(popupInnerDiv);

    document.querySelector('.main').appendChild(popup);
  }

  function closePopup() {
    document.querySelector('.popupWrapper').remove();
  }

  /**
   * Function checks if the selected date,product,amount of guests is available.
   * the function calls the backend checkAvailableTickets function which is located in functions.php and receives either an 200 response or 401 with
   * the number of available tickets and then calls a function to generate appropriate popup in case of an 401
   */
  function checkTicketAvailability() {

    let date =  jQuery('input#field_arrivedate, input#dateOfArrivalSelector').datepicker('getDate'); //get date from datepicker
    if (date) {
      date= dateStringFormat(date); //convert date to dd/mm/yyyy format
    }

    let requestedTickets = numOfPeople.options[numOfPeople.selectedIndex].text; // amount of people selected
    let product= selectedProduct.options[selectedProduct.selectedIndex].value; // product_id


    // check if all fields are set and have values
    if (date && requestedTickets && product) {
      // eslint-disable-next-line no-undef
      let dateLimit = datesAvailability[product][date];
      const availableTickets = dateLimit ? Math.max(Object.values(dateLimit).reduce((a, b) => a + b, 0), 0) : 0;
      if (!dateLimit || availableTickets >= requestedTickets) {
        document.querySelector('.frm_final_submit').removeAttribute('disabled');
        submit_button.classList.remove('submit-button-disabled');
        submit_button.classList.add('submit-button-enabled');
      } else {
        document.querySelector('.frm_final_submit').setAttribute('disabled', true);
        submit_button.classList.remove('submit-button-enabled');
        submit_button.classList.add('submit-button-disabled');
        createPopupElement(availableTickets);
      }
    }
  }


  /**
   * Function accepts date object and returns dd/mm/yyyy date format string
   * @param date
   * @returns {string}
   */
  function dateStringFormat(date)
  {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    date = day + '/' + month + '/' + year;
    return date;
  }
});




// WEBPACK FOOTER //
// ./scripts/main.js